import type { GetBillingAccountOverviewResponse } from "@nlc/shared-types";

import { TagIcon } from "lucide-react";

import { formatCurrency } from "../../../utils/format-currency";

interface CreditBalanceCardProps {
  readonly creditBalance: GetBillingAccountOverviewResponse["creditBalance"];
}

export function CreditBalanceCard({ creditBalance }: CreditBalanceCardProps) {
  return (
    <div className="flex items-start justify-between rounded-xl border border-border-secondary bg-bg-primary px-3xl py-xl">
      <div className="flex flex-col gap-xs">
        <h3 className="text-sm font-medium text-text-secondary">
          Credit balance
        </h3>
        <p className="text-4xl font-bold text-text-primary">
          {formatCurrency(creditBalance.amount, creditBalance.currency)}
        </p>
      </div>
      <div className="h-10 w-10 rounded-md bg-bg-brand-secondary flex items-center justify-center">
        <TagIcon className="text-text-brand-primary" size={20} />
      </div>
    </div>
  );
}
